import { IEnvironment } from 'src/ts/interfaces';

export const envVars: IEnvironment = {
  production: {
    env: 'production',
    data_dog: {
      token: 'pubb6f5fd39e674dc4d3fbc0524e3b83d6d',
      url: 'https://logs.browser-intake-datadoghq.com/api',
      queue_health_embed_url:
        'https://p.datadoghq.com/sb/embed/3d57bffc-bfca-11eb-a4d7-da7ad0900002-66dc9f222c050d832fd9f63fec58607c'
    },
    server_url: 'https://fraud-api.snappt.com',
    document_portal: 'https://documentportal.info',
    frontend_url: 'https://fraud.snappt.com',
    api_url: 'https://fraud-api.snappt.com/v2',
    epa_url: 'https://enterprise-api.snappt.com',
    settings_service_url: 'https://settings.prod.snappt.com',
    feature_flag_api_url: 'https://feature-flag-api.snappt.com',
    bucket_url: 'https://fraud-images-production.s3.us-west-2.amazonaws.com',
    metabase: {
      url: 'https://snappt.metabaseapp.com',
      dashboards: {
        my_work_performance: {
          id: 101,
          report_type: 'my_work_performance'
        },
        team_performance: {
          id: 140,
          report_type: 'team_performance'
        },
        reporting_tab: {
          id: 85,
          report_type: 'reporting_tab'
        },
        reporting_sla: {
          id: 158,
          report_type: 'reporting_sla'
        }
      }
    },
    adobe: {
      pdf_token: '1d3acc97f42347228047f8a47ef00726'
    },
    heap: {
      app_id: '2637664708'
    },
    google: {
      token: 'AIzaSyA3Eg8t47-LrOvjweLoCqOHX2CWfBYcZs4'
    },
    pendo: {
      apiKey: 'a11fd049-07d0-43ee-4f0a-ccb2253b9e1e'
    },
    salesforce: {
      orgId: '00DDn00000C1pbz',
      eswConfigDevName: 'customer_service_bot',
      siteUrl: 'https://snappt.my.site.com/ESWcustomerservicebot1774035837248',
      scrt2Url: 'https://snappt.my.salesforce-scrt.com'
    },
    databricks: {
      base_url: 'https://dbc-9ca0f5e0-2208.cloud.databricks.com',
      workspace_id: '9ca0f5e0-2208',
      embedded_dashboards: {
        snappt_reporting_2_dashboard_id: '01f0d090d7561ef3be720fc2c6d667f8',
        ops_dashboard_id: '01f09e0ed2d616e2a3d570c565c35928',
        ninja_reporting_dashboard_id: '01f17e6256e412d0a2f72bc45d61522a',
        application_tracking_dashboard_id: '01f1b6c686011ceabb36a0e319c1a4f0'
      }
    }
  },
  development: {
    env: 'development',
    data_dog: {
      token: 'pub1352fde5b374961a984cb9b33a60f641',
      url: 'https://logs.browser-intake-datadoghq.com/api',
      queue_health_embed_url:
        'https://p.datadoghq.com/sb/embed/3d57bffc-bfca-11eb-a4d7-da7ad0900002-66dc9f222c050d832fd9f63fec58607c'
    },
    server_url: 'http://localhost:4000',
    document_portal: 'https://documentportal.info',
    frontend_url: 'http://localhost:3000',
    api_url: 'http://localhost:4000/v2',
    epa_url: 'http://localhost:3500',
    settings_service_url: 'http://localhost:3310',
    feature_flag_api_url: 'http://localhost:3600',
    bucket_url: 'http://localstack:4566/fraud-images-dev',
    metabase: {
      url: 'https://snappt.metabaseapp.com',
      dashboards: {
        my_work_performance: {
          id: 109,
          report_type: 'my_work_performance'
        },
        team_performance: {
          id: 127,
          report_type: 'team_performance'
        },
        reporting_tab: {
          id: 112,
          report_type: 'reporting_tab'
        },
        reporting_sla: {
          id: 156,
          report_type: 'reporting_sla'
        }
      }
    },
    adobe: {
      pdf_token: 'a2bf3267699b4cb89d6b9166846ff2ff'
    },
    heap: {
      app_id: '2509813560'
    },
    google: {
      token: 'AIzaSyA3Eg8t47-LrOvjweLoCqOHX2CWfBYcZs4'
    },
    pendo: {
      apiKey: 'a11fd049-07d0-43ee-4f0a-ccb2253b9e1e'
    },
    databricks: {
      base_url: 'https://dbc-9ca0f5e0-2208.cloud.databricks.com',
      workspace_id: '9ca0f5e0-2208',
      embedded_dashboards: {
        snappt_reporting_2_dashboard_id: '01f0d090d7561ef3be720fc2c6d667f8',
        ops_dashboard_id: '01f09e0ed2d616e2a3d570c565c35928',
        ninja_reporting_dashboard_id: '01f17e6256e412d0a2f72bc45d61522a',
        application_tracking_dashboard_id: '01f1b6c686011ceabb36a0e319c1a4f0'
      }
    }
  },
  wintheknifefightDev: {
    env: 'development',
    data_dog: {
      token: 'pub1352fde5b374961a984cb9b33a60f641',
      url: 'https://logs.browser-intake-datadoghq.com/api',
      queue_health_embed_url:
        'https://p.datadoghq.com/sb/embed/3d57bffc-bfca-11eb-a4d7-da7ad0900002-66dc9f222c050d832fd9f63fec58607c'
    },
    server_url: 'http://wintheknifefight:4000',
    document_portal: 'https://documentportal.info',
    frontend_url: 'http://wintheknifefight:3000',
    api_url: 'http://wintheknifefight:4000/v2',
    epa_url: 'http://localhost:3500',
    settings_service_url: 'http://localhost:3310',
    feature_flag_api_url: 'http://localhost:3600',
    bucket_url: 'http://localstack:4566/fraud-images-dev',
    metabase: {
      url: 'https://snappt.metabaseapp.com',
      dashboards: {
        my_work_performance: {
          id: 109,
          report_type: 'my_work_performance'
        },
        team_performance: {
          id: 127,
          report_type: 'team_performance'
        },
        reporting_tab: {
          id: 112,
          report_type: 'reporting_tab'
        },
        reporting_sla: {
          id: 156,
          report_type: 'reporting_sla'
        }
      }
    },
    adobe: {
      pdf_token: 'a2bf3267699b4cb89d6b9166846ff2ff'
    },
    heap: {
      app_id: '2509813560'
    },
    google: {
      token: 'AIzaSyA3Eg8t47-LrOvjweLoCqOHX2CWfBYcZs4'
    },
    pendo: {
      apiKey: 'a11fd049-07d0-43ee-4f0a-ccb2253b9e1e'
    },
    databricks: {
      base_url: 'https://dbc-9ca0f5e0-2208.cloud.databricks.com',
      workspace_id: '9ca0f5e0-2208',
      embedded_dashboards: {
        snappt_reporting_2_dashboard_id: '01f0d090d7561ef3be720fc2c6d667f8',
        ops_dashboard_id: '01f09e0ed2d616e2a3d570c565c35928',
        ninja_reporting_dashboard_id: '01f17e6256e412d0a2f72bc45d61522a',
        application_tracking_dashboard_id: '01f1b6c686011ceabb36a0e319c1a4f0'
      }
    }
  },
  ralph: {
    env: 'ralph',
    data_dog: {
      token: 'pubd9703d48afec87ab3b6f41172798069f',
      url: 'https://logs.browser-intake-datadoghq.com/api',
      queue_health_embed_url:
        'https://p.datadoghq.com/sb/embed/3d57bffc-bfca-11eb-a4d7-da7ad0900002-66dc9f222c050d832fd9f63fec58607c'
    },
    server_url: 'https://fraud-api-ralph.snappt.com',
    document_portal: 'https://ralph.documentportal.info',
    frontend_url: 'https://fraud-ralph.snappt.com',
    api_url: 'https://fraud-api-ralph.snappt.com/v2',
    epa_url: 'https://ralph-enterprise-api.snappt.com',
    // No settings-service deployment for this env; points at the nearest one.
    settings_service_url: 'https://settings.dev.snappt.com',
    feature_flag_api_url: 'https://feature-flag-api-ralph.snappt.com',
    bucket_url: 'https://fraud-images-ralph.s3.us-west-2.amazonaws.com',
    metabase: {
      url: 'https://snappt.metabaseapp.com',
      dashboards: {
        my_work_performance: {
          id: 421,
          report_type: 'my_work_performance'
        },
        reporting_tab: {
          id: 419,
          report_type: 'reporting_tab'
        },
        reporting_sla: {
          id: 447,
          report_type: 'reporting_sla'
        },
        // Un-used feature; update and validate before use.
        team_performance: {
          id: 127,
          report_type: 'team_performance'
        }
      }
    },
    adobe: {
      pdf_token: '1d3acc97f42347228047f8a47ef00726'
    },
    heap: {
      app_id: '2509813560'
    },
    google: {
      token: 'AIzaSyA3Eg8t47-LrOvjweLoCqOHX2CWfBYcZs4'
    },
    pendo: {
      apiKey: 'a11fd049-07d0-43ee-4f0a-ccb2253b9e1e'
    },
    databricks: {
      base_url: 'https://dbc-9ca0f5e0-2208.cloud.databricks.com',
      workspace_id: '9ca0f5e0-2208',
      embedded_dashboards: {
        snappt_reporting_2_dashboard_id: '01f0d090d7561ef3be720fc2c6d667f8',
        ops_dashboard_id: '01f09e0ed2d616e2a3d570c565c35928',
        ninja_reporting_dashboard_id: '01f17e6256e412d0a2f72bc45d61522a',
        application_tracking_dashboard_id: '01f1b6c686011ceabb36a0e319c1a4f0'
      }
    }
  },
  demo: {
    env: 'demo',
    data_dog: {
      token: 'pubf32334de813e2f15f84246421efcc923',
      url: 'https://logs.browser-intake-datadoghq.com/api',
      queue_health_embed_url:
        'https://p.datadoghq.com/sb/embed/3d57bffc-bfca-11eb-a4d7-da7ad0900002-66dc9f222c050d832fd9f63fec58607c'
    },
    server_url: 'https://fraud-api-demo.snappt.com',
    document_portal: 'https://demo.documentportal.info',
    frontend_url: 'https://fraud-demo.snappt.com',
    api_url: 'https://fraud-api-demo.snappt.com/v2',
    epa_url: 'https://demo-enterprise-api.snappt.com',
    settings_service_url: 'https://settings.demo.snappt.com',
    feature_flag_api_url: 'https://feature-flag-api-demo.snappt.com',
    bucket_url: 'https://fraud-images-demo.s3.us-west-2.amazonaws.com',
    metabase: {
      url: 'https://snappt.metabaseapp.com',
      dashboards: {
        my_work_performance: {
          id: 454,
          report_type: 'my_work_performance'
        },
        reporting_tab: {
          id: 422,
          report_type: 'reporting_tab'
        },
        reporting_sla: {
          id: 451,
          report_type: 'reporting_sla'
        },
        // Un-used feature; update and validate before use.
        team_performance: {
          id: 127,
          report_type: 'team_performance'
        }
      }
    },
    adobe: {
      pdf_token: '1d3acc97f42347228047f8a47ef00726'
    },
    heap: {
      app_id: '2509813560'
    },
    google: {
      token: 'AIzaSyA3Eg8t47-LrOvjweLoCqOHX2CWfBYcZs4'
    },
    pendo: {
      apiKey: 'a11fd049-07d0-43ee-4f0a-ccb2253b9e1e'
    },
    databricks: {
      base_url: 'https://dbc-9ca0f5e0-2208.cloud.databricks.com',
      workspace_id: '9ca0f5e0-2208',
      embedded_dashboards: {
        snappt_reporting_2_dashboard_id: '01f0d090d7561ef3be720fc2c6d667f8',
        ops_dashboard_id: '01f09e0ed2d616e2a3d570c565c35928',
        ninja_reporting_dashboard_id: '01f17e6256e412d0a2f72bc45d61522a',
        application_tracking_dashboard_id: '01f1b6c686011ceabb36a0e319c1a4f0'
      }
    }
  },
  sandbox: {
    env: 'sandbox',
    data_dog: {
      token: 'pubf32334de813e2f15f84246421efcc923',
      url: 'https://logs.browser-intake-datadoghq.com/api',
      queue_health_embed_url:
        'https://p.datadoghq.com/sb/embed/3d57bffc-bfca-11eb-a4d7-da7ad0900002-66dc9f222c050d832fd9f63fec58607c'
    },
    server_url: 'https://fraud-api-sandbox.snappt.com',
    document_portal: 'https://sandbox.documentportal.info',
    frontend_url: 'https://fraud-sandbox.snappt.com',
    api_url: 'https://fraud-api-sandbox.snappt.com/v2',
    epa_url: 'https://enterprise-api-sandbox.snappt.com',
    // No settings-service deployment for this env; points at the nearest one.
    settings_service_url: 'https://settings.test.snappt.com',
    feature_flag_api_url: 'https://feature-flag-api-sandbox.snappt.com',
    bucket_url: 'https://fraud-images-sandbox.s3.us-west-2.amazonaws.com',
    metabase: {
      url: 'https://snappt.metabaseapp.com',
      dashboards: {
        my_work_performance: {
          id: 453,
          report_type: 'my_work_performance'
        },
        reporting_tab: {
          id: 420,
          report_type: 'reporting_tab'
        },
        reporting_sla: {
          id: 450,
          report_type: 'reporting_sla'
        },
        // Un-used feature; update and validate before use.
        team_performance: {
          id: 127,
          report_type: 'team_performance'
        }
      }
    },
    adobe: {
      pdf_token: '1d3acc97f42347228047f8a47ef00726'
    },
    heap: {
      app_id: '2509813560'
    },
    google: {
      token: 'AIzaSyA3Eg8t47-LrOvjweLoCqOHX2CWfBYcZs4'
    },
    pendo: {
      apiKey: 'a11fd049-07d0-43ee-4f0a-ccb2253b9e1e'
    },
    databricks: {
      base_url: 'https://dbc-9ca0f5e0-2208.cloud.databricks.com',
      workspace_id: '9ca0f5e0-2208',
      embedded_dashboards: {
        snappt_reporting_2_dashboard_id: '01f0d090d7561ef3be720fc2c6d667f8',
        ops_dashboard_id: '01f09e0ed2d616e2a3d570c565c35928',
        ninja_reporting_dashboard_id: '01f17e6256e412d0a2f72bc45d61522a',
        application_tracking_dashboard_id: '01f1b6c686011ceabb36a0e319c1a4f0'
      }
    }
  },
  dev: {
    env: 'dev',
    data_dog: {
      token: 'pubd9703d48afec87ab3b6f41172798069f',
      url: 'https://logs.browser-intake-datadoghq.com/api',
      queue_health_embed_url:
        'https://p.datadoghq.com/sb/embed/3d57bffc-bfca-11eb-a4d7-da7ad0900002-66dc9f222c050d832fd9f63fec58607c'
    },
    server_url: 'https://fraud-api.dev.snappt.com',
    document_portal: 'https://dev.documentportal.info',
    frontend_url: 'https://fraud.dev.snappt.com',
    api_url: 'https://fraud-api.dev.snappt.com/v2',
    epa_url: 'https://enterprise-api.dev.snappt.com',
    settings_service_url: 'https://settings.dev.snappt.com',
    feature_flag_api_url: 'https://feature-flags.dev.snappt.com',
    metabase: {
      url: 'https://snappt.metabaseapp.com',
      dashboards: {
        my_work_performance: {
          id: 421,
          report_type: 'my_work_performance'
        },
        reporting_tab: {
          id: 419,
          report_type: 'reporting_tab'
        },
        reporting_sla: {
          id: 447,
          report_type: 'reporting_sla'
        },
        // Un-used feature; update and validate before use.
        team_performance: {
          id: 127,
          report_type: 'team_performance'
        }
      }
    },
    adobe: {
      pdf_token: '1d3acc97f42347228047f8a47ef00726'
    },
    heap: {
      app_id: '2509813560'
    },
    google: {
      token: 'AIzaSyA3Eg8t47-LrOvjweLoCqOHX2CWfBYcZs4'
    },
    pendo: {
      apiKey: 'a11fd049-07d0-43ee-4f0a-ccb2253b9e1e'
    },
    databricks: {
      base_url: 'https://dbc-9ca0f5e0-2208.cloud.databricks.com',
      workspace_id: '9ca0f5e0-2208',
      embedded_dashboards: {
        snappt_reporting_2_dashboard_id: '01f0d090d7561ef3be720fc2c6d667f8',
        ops_dashboard_id: '01f09e0ed2d616e2a3d570c565c35928',
        ninja_reporting_dashboard_id: '01f17e6256e412d0a2f72bc45d61522a',
        application_tracking_dashboard_id: '01f1b6c686011ceabb36a0e319c1a4f0'
      }
    }
  },
  newDemo: {
    env: 'demo',
    data_dog: {
      token: 'pubf32334de813e2f15f84246421efcc923',
      url: 'https://logs.browser-intake-datadoghq.com/api',
      queue_health_embed_url:
        'https://p.datadoghq.com/sb/embed/3d57bffc-bfca-11eb-a4d7-da7ad0900002-66dc9f222c050d832fd9f63fec58607c'
    },
    server_url: 'https://fraud-api.demo.snappt.com',
    document_portal: 'https://demo.documentportal.info',
    frontend_url: 'https://fraud.demo.snappt.com',
    api_url: 'https://fraud-api.demo.snappt.com/v2',
    epa_url: 'https://enterprise-api.demo.snappt.com',
    settings_service_url: 'https://settings.demo.snappt.com',
    feature_flag_api_url: 'https://feature-flags.demo.snappt.com',
    metabase: {
      url: 'https://snappt.metabaseapp.com',
      dashboards: {
        my_work_performance: {
          id: 454,
          report_type: 'my_work_performance'
        },
        reporting_tab: {
          id: 422,
          report_type: 'reporting_tab'
        },
        reporting_sla: {
          id: 451,
          report_type: 'reporting_sla'
        },
        // Un-used feature; update and validate before use.
        team_performance: {
          id: 127,
          report_type: 'team_performance'
        }
      }
    },
    adobe: {
      pdf_token: '1d3acc97f42347228047f8a47ef00726'
    },
    heap: {
      app_id: '2509813560'
    },
    google: {
      token: 'AIzaSyA3Eg8t47-LrOvjweLoCqOHX2CWfBYcZs4'
    },
    pendo: {
      apiKey: 'a11fd049-07d0-43ee-4f0a-ccb2253b9e1e'
    },
    databricks: {
      base_url: 'https://dbc-9ca0f5e0-2208.cloud.databricks.com',
      workspace_id: '9ca0f5e0-2208',
      embedded_dashboards: {
        snappt_reporting_2_dashboard_id: '01f0d090d7561ef3be720fc2c6d667f8',
        ops_dashboard_id: '01f09e0ed2d616e2a3d570c565c35928',
        ninja_reporting_dashboard_id: '01f17e6256e412d0a2f72bc45d61522a',
        application_tracking_dashboard_id: '01f1b6c686011ceabb36a0e319c1a4f0'
      }
    }
  },
  test: {
    env: 'test',
    data_dog: {
      token: 'pubf32334de813e2f15f84246421efcc923',
      url: 'https://logs.browser-intake-datadoghq.com/api',
      queue_health_embed_url:
        'https://p.datadoghq.com/sb/embed/3d57bffc-bfca-11eb-a4d7-da7ad0900002-66dc9f222c050d832fd9f63fec58607c'
    },
    server_url: 'https://fraud-api.test.snappt.com',
    document_portal: 'https://test.documentportal.info',
    frontend_url: 'https://fraud.test.snappt.com',
    api_url: 'https://fraud-api.test.snappt.com/v2',
    epa_url: 'https://enterprise-api.test.snappt.com',
    settings_service_url: 'https://settings.test.snappt.com',
    feature_flag_api_url: 'https://feature-flags.test.snappt.com',
    metabase: {
      url: 'https://snappt.metabaseapp.com',
      dashboards: {
        my_work_performance: {
          id: 453,
          report_type: 'my_work_performance'
        },
        reporting_tab: {
          id: 420,
          report_type: 'reporting_tab'
        },
        reporting_sla: {
          id: 450,
          report_type: 'reporting_sla'
        },
        // Un-used feature; update and validate before use.
        team_performance: {
          id: 127,
          report_type: 'team_performance'
        }
      }
    },
    adobe: {
      pdf_token: '1d3acc97f42347228047f8a47ef00726'
    },
    heap: {
      app_id: '2509813560'
    },
    google: {
      token: 'AIzaSyA3Eg8t47-LrOvjweLoCqOHX2CWfBYcZs4'
    },
    pendo: {
      apiKey: 'a11fd049-07d0-43ee-4f0a-ccb2253b9e1e'
    },
    databricks: {
      base_url: 'https://dbc-9ca0f5e0-2208.cloud.databricks.com',
      workspace_id: '9ca0f5e0-2208',
      embedded_dashboards: {
        snappt_reporting_2_dashboard_id: '01f0d090d7561ef3be720fc2c6d667f8',
        ops_dashboard_id: '01f09e0ed2d616e2a3d570c565c35928',
        ninja_reporting_dashboard_id: '01f17e6256e412d0a2f72bc45d61522a',
        application_tracking_dashboard_id: '01f1b6c686011ceabb36a0e319c1a4f0'
      }
    }
  },
  uat: {
    env: 'uat',
    data_dog: {
      token: 'pubf32334de813e2f15f84246421efcc923',
      url: 'https://logs.browser-intake-datadoghq.com/api',
      queue_health_embed_url:
        'https://p.datadoghq.com/sb/embed/3d57bffc-bfca-11eb-a4d7-da7ad0900002-66dc9f222c050d832fd9f63fec58607c'
    },
    server_url: 'https://fraud-api.uat.snappt.com',
    document_portal: 'https://uat.documentportal.info',
    frontend_url: 'https://fraud.uat.snappt.com',
    api_url: 'https://fraud-api.uat.snappt.com/v2',
    epa_url: 'https://enterprise-api.uat.snappt.com',
    // No settings-service deployment for this env; points at the nearest one.
    settings_service_url: 'https://settings.test.snappt.com',
    feature_flag_api_url: 'https://feature-flags.uat.snappt.com',
    metabase: {
      url: 'https://snappt.metabaseapp.com',
      dashboards: {
        my_work_performance: {
          id: 453,
          report_type: 'my_work_performance'
        },
        reporting_tab: {
          id: 420,
          report_type: 'reporting_tab'
        },
        reporting_sla: {
          id: 450,
          report_type: 'reporting_sla'
        },
        // Un-used feature; update and validate before use.
        team_performance: {
          id: 127,
          report_type: 'team_performance'
        }
      }
    },
    adobe: {
      pdf_token: '1d3acc97f42347228047f8a47ef00726'
    },
    heap: {
      app_id: '2509813560'
    },
    google: {
      token: 'AIzaSyA3Eg8t47-LrOvjweLoCqOHX2CWfBYcZs4'
    },
    databricks: {
      base_url: 'https://dbc-9ca0f5e0-2208.cloud.databricks.com',
      workspace_id: '9ca0f5e0-2208',
      embedded_dashboards: {
        snappt_reporting_2_dashboard_id: '01f0d090d7561ef3be720fc2c6d667f8',
        ops_dashboard_id: '01f09e0ed2d616e2a3d570c565c35928',
        ninja_reporting_dashboard_id: '01f17e6256e412d0a2f72bc45d61522a',
        application_tracking_dashboard_id: '01f1b6c686011ceabb36a0e319c1a4f0'
      }
    }
  },
  prod: {
    env: 'prod',
    data_dog: {
      token: 'pubf32334de813e2f15f84246421efcc923',
      url: 'https://logs.browser-intake-datadoghq.com/api',
      queue_health_embed_url:
        'https://p.datadoghq.com/sb/embed/3d57bffc-bfca-11eb-a4d7-da7ad0900002-66dc9f222c050d832fd9f63fec58607c'
    },
    server_url: 'https://fraud-api.prod.snappt.com',
    document_portal: 'https://prod.documentportal.info',
    frontend_url: 'https://fraud.prod.snappt.com',
    api_url: 'https://fraud-api.prod.snappt.com/v2',
    epa_url: 'https://enterprise-api.prod.snappt.com',
    settings_service_url: 'https://settings.prod.snappt.com',
    feature_flag_api_url: 'https://feature-flags.prod.snappt.com',
    metabase: {
      url: 'https://snappt.metabaseapp.com',
      dashboards: {
        my_work_performance: {
          id: 101,
          report_type: 'my_work_performance'
        },
        team_performance: {
          id: 140,
          report_type: 'team_performance'
        },
        reporting_tab: {
          id: 85,
          report_type: 'reporting_tab'
        },
        reporting_sla: {
          id: 158,
          report_type: 'reporting_sla'
        }
      }
    },
    adobe: {
      pdf_token: '1d3acc97f42347228047f8a47ef00726'
    },
    heap: {
      app_id: '2637664708'
    },
    google: {
      token: 'AIzaSyA3Eg8t47-LrOvjweLoCqOHX2CWfBYcZs4'
    },
    pendo: {
      apiKey: 'a11fd049-07d0-43ee-4f0a-ccb2253b9e1e'
    },
    salesforce: {
      orgId: '00DDn00000C1pbz',
      eswConfigDevName: 'customer_service_bot',
      siteUrl: 'https://snappt.my.site.com/ESWcustomerservicebot1774035837248',
      scrt2Url: 'https://snappt.my.salesforce-scrt.com'
    },
    databricks: {
      base_url: 'https://dbc-9ca0f5e0-2208.cloud.databricks.com',
      workspace_id: '9ca0f5e0-2208',
      embedded_dashboards: {
        snappt_reporting_2_dashboard_id: '01f0d090d7561ef3be720fc2c6d667f8',
        ops_dashboard_id: '01f09e0ed2d616e2a3d570c565c35928',
        ninja_reporting_dashboard_id: '01f17e6256e412d0a2f72bc45d61522a',
        application_tracking_dashboard_id: '01f1b6c686011ceabb36a0e319c1a4f0'
      }
    }
  }
};
